// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Search {
    flex: 1 1 auto;
    display: inline-flex;
    position: relative;
    align-items: center;
    vertical-align: middle;
    max-width: 70ch;
    z-index: 4;
    color: var(--text-color);
}

#Search div.searchbar-wrapper {
    position: relative;
    display: inline-block;
    flex: 1 1 auto;
    height: 2.5em;
}

#Search div.searchbar-container {
    width: 100%;
    display: inline-flex;
}

#Search input.searchbar {
    flex: 1 1 auto;
    height: 2.5em;
    width: 0;
    min-width: 10ch;
}

#Search span.searchbar-addon {
    flex: 0 0 auto;
    height: 2.5em;
    width: 2.5em;
    background-color: var(--button-bg-color);
    color: var(--button-text-color);
    border-top: 1px solid var(--border-color);
    border-right: 1px solid var(--border-color);
    border-bottom: 1px solid var(--border-color);
    position: relative;
    align-items: center;
    display: flex;
    justify-content: center;
}

#Search span.searchbar-addon-active {
    background-color: var(--button-bg-color-hover);
    color: var(--button-text-color-hover);
}

#Search span.searchbar-addon-filter-active {
    background-color: var(--button-bg-color-active);
    color: var(--button-text-color-active);
}

#Search span.searchbar-addon-menu-icon {
    position: absolute;
    right: 0.125em;
    bottom: 0.125em;
    font-size: 70%;
    color: var(--text-color);
}

#Search ul.searchbar-provider-selection {
    position: absolute;
    top: 100%;
    right: -1px;
    background-color: var(--list-bg-color);
    border: 1px solid var(--border-color);
    list-style-type: none;
    margin: 0;
    padding: 0;
    color: var(--text-color);
}

#Search ul.searchbar-provider-selection li {
    padding: 0.5em;
    white-space: nowrap;
}

#Search li.searchbar-provider-selection-all {
    border-bottom: 1px solid var(--border-color);
}

#Search li.searchbar-provider-selection-active {
    background-color: var(--list-item-bg-color-active);
    color: var(--list-item-text-color-active);
}

#Search ul.searchbar-provider-selection li:hover {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}

#Search div.spinner {
    width: 2em;
    height: 2em;
    margin: 0.25em;
}

#Search div.search-form {
    top: 0;
    width: 100%;
    position: absolute;
    z-index: 100;
    background-color: var(--button-bg-color);
    border: 1px solid var(--border-color);
}

#Search div.search-form > table {
    width: 100%;
}

#Search div.search-form > table td {
    padding: 0.125em 0.25em;
}

#Search div.search-form > table input {
    width: 100%;
    min-width: 0;
    max-width: none;
}

#Search div.search-form div.search-form-buttons {
    text-align: right;
    padding: 0.5em 0.25em;
}

#Search div.search-form div.search-form-buttons > button {
    padding: 0.25em;
    margin-left: 0.25em;
}

#Search ul.search-results {
    top: 100%;
    position: absolute;
    background-color: var(--list-bg-color);
    max-height: calc(100vh - var(--topbar-height) - var(--bottombar-height));
    max-height: calc(var(--vh, 1vh) * 100 - var(--topbar-height) - var(--bottombar-height));
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0;
    list-style-type: none;
    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);
    font-size: small;
}

#Search ul.search-results ul {
    list-style-type: none;
    padding: 0;
}

#Search ul.search-results ul li {
    padding: 0.25em 0.25em 0.25em 1em;
    display: flex;
    align-items: center;
    cursor: pointer;
}

#Search ul.search-results li.search-results-noresults {
    padding: 0.25em 0.25em 0.25em 1em;
    font-style: italic;
    color: var(--text-color-disabled);
}

#Search ul.search-results ul li > img {
    flex: 0 0 6em;
    width: 6em;
    height: auto;
    border: 1px solid var(--border-color);
    background-color: white;
    border-radius: 0.5em;
    margin-right: 1em;
}

#Search ul.search-results ul li > span {
    flex: 1 1 auto;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

#Search ul.search-results ul li > span.icon {
    flex: 0 0 auto;
    border: 1px solid var(--border-color);
    background-color: white;
    padding: 0.25em;
    border-radius: 0.25em;
}

#Search ul.search-results ul li > span.icon:hover {
    border-color: var(--color-active);
}

#Search ul.search-results ul li:hover {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}

#Search ul.search-results .search-results-category-title {
    background-color: var(--list-section-bg-color);
    color: var(--list-section-text-color);
    font-weight: bold;
    display: block;
    padding: 0.5em;
}
`, "",{"version":3,"sources":["webpack://./qwc2/components/style/Search.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,YAAY;IACZ,wCAAwC;IACxC,+BAA+B;IAC/B,yCAAyC;IACzC,2CAA2C;IAC3C,4CAA4C;IAC5C,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,8CAA8C;IAC9C,qCAAqC;AACzC;;AAEA;IACI,+CAA+C;IAC/C,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,cAAc;IACd,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,sCAAsC;IACtC,qCAAqC;IACrC,qBAAqB;IACrB,SAAS;IACT,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,UAAU;IACV,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,MAAM;IACN,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,qCAAqC;AACzC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,sCAAsC;IACtC,wEAAwE;IACxE,uFAAuF;IACvF,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,qBAAqB;IACrB,gDAAgD;IAChD,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,UAAU;IACV,YAAY;IACZ,qCAAqC;IACrC,uBAAuB;IACvB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,qCAAqC;IACrC,uBAAuB;IACvB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,8CAA8C;IAC9C,qCAAqC;IACrC,iBAAiB;IACjB,cAAc;IACd,cAAc;AAClB","sourcesContent":["#Search {\n    flex: 1 1 auto;\n    display: inline-flex;\n    position: relative;\n    align-items: center;\n    vertical-align: middle;\n    max-width: 70ch;\n    z-index: 4;\n    color: var(--text-color);\n}\n\n#Search div.searchbar-wrapper {\n    position: relative;\n    display: inline-block;\n    flex: 1 1 auto;\n    height: 2.5em;\n}\n\n#Search div.searchbar-container {\n    width: 100%;\n    display: inline-flex;\n}\n\n#Search input.searchbar {\n    flex: 1 1 auto;\n    height: 2.5em;\n    width: 0;\n    min-width: 10ch;\n}\n\n#Search span.searchbar-addon {\n    flex: 0 0 auto;\n    height: 2.5em;\n    width: 2.5em;\n    background-color: var(--button-bg-color);\n    color: var(--button-text-color);\n    border-top: 1px solid var(--border-color);\n    border-right: 1px solid var(--border-color);\n    border-bottom: 1px solid var(--border-color);\n    position: relative;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n}\n\n#Search span.searchbar-addon-active {\n    background-color: var(--button-bg-color-hover);\n    color: var(--button-text-color-hover);\n}\n\n#Search span.searchbar-addon-filter-active {\n    background-color: var(--button-bg-color-active);\n    color: var(--button-text-color-active);\n}\n\n#Search span.searchbar-addon-menu-icon {\n    position: absolute;\n    right: 0.125em;\n    bottom: 0.125em;\n    font-size: 70%;\n    color: var(--text-color);\n}\n\n#Search ul.searchbar-provider-selection {\n    position: absolute;\n    top: 100%;\n    right: -1px;\n    background-color: var(--list-bg-color);\n    border: 1px solid var(--border-color);\n    list-style-type: none;\n    margin: 0;\n    padding: 0;\n    color: var(--text-color);\n}\n\n#Search ul.searchbar-provider-selection li {\n    padding: 0.5em;\n    white-space: nowrap;\n}\n\n#Search li.searchbar-provider-selection-all {\n    border-bottom: 1px solid var(--border-color);\n}\n\n#Search li.searchbar-provider-selection-active {\n    background-color: var(--list-item-bg-color-active);\n    color: var(--list-item-text-color-active);\n}\n\n#Search ul.searchbar-provider-selection li:hover {\n    background-color: var(--list-item-bg-color-hover);\n    color: var(--list-item-text-color-hover);\n}\n\n#Search div.spinner {\n    width: 2em;\n    height: 2em;\n    margin: 0.25em;\n}\n\n#Search div.search-form {\n    top: 0;\n    width: 100%;\n    position: absolute;\n    z-index: 100;\n    background-color: var(--button-bg-color);\n    border: 1px solid var(--border-color);\n}\n\n#Search div.search-form > table {\n    width: 100%;\n}\n\n#Search div.search-form > table td {\n    padding: 0.125em 0.25em;\n}\n\n#Search div.search-form > table input {\n    width: 100%;\n    min-width: 0;\n    max-width: none;\n}\n\n#Search div.search-form div.search-form-buttons {\n    text-align: right;\n    padding: 0.5em 0.25em;\n}\n\n#Search div.search-form div.search-form-buttons > button {\n    padding: 0.25em;\n    margin-left: 0.25em;\n}\n\n#Search ul.search-results {\n    top: 100%;\n    position: absolute;\n    background-color: var(--list-bg-color);\n    max-height: calc(100vh - var(--topbar-height) - var(--bottombar-height));\n    max-height: calc(var(--vh, 1vh) * 100 - var(--topbar-height) - var(--bottombar-height));\n    width: 100%;\n    overflow-x: hidden;\n    overflow-y: auto;\n    padding: 0;\n    list-style-type: none;\n    box-shadow: 0px 2px 4px rgba(136, 136, 136, 0.5);\n    font-size: small;\n}\n\n#Search ul.search-results ul {\n    list-style-type: none;\n    padding: 0;\n}\n\n#Search ul.search-results ul li {\n    padding: 0.25em 0.25em 0.25em 1em;\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n\n#Search ul.search-results li.search-results-noresults {\n    padding: 0.25em 0.25em 0.25em 1em;\n    font-style: italic;\n    color: var(--text-color-disabled);\n}\n\n#Search ul.search-results ul li > img {\n    flex: 0 0 6em;\n    width: 6em;\n    height: auto;\n    border: 1px solid var(--border-color);\n    background-color: white;\n    border-radius: 0.5em;\n    margin-right: 1em;\n}\n\n#Search ul.search-results ul li > span {\n    flex: 1 1 auto;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n#Search ul.search-results ul li > span.icon {\n    flex: 0 0 auto;\n    border: 1px solid var(--border-color);\n    background-color: white;\n    padding: 0.25em;\n    border-radius: 0.25em;\n}\n\n#Search ul.search-results ul li > span.icon:hover {\n    border-color: var(--color-active);\n}\n\n#Search ul.search-results ul li:hover {\n    background-color: var(--list-item-bg-color-hover);\n    color: var(--list-item-text-color-hover);\n}\n\n#Search ul.search-results .search-results-category-title {\n    background-color: var(--list-section-bg-color);\n    color: var(--list-section-text-color);\n    font-weight: bold;\n    display: block;\n    padding: 0.5em;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
